module.exports = __webpack_public_path__ + "images/saaremaa/android-icon-192x192.png";